var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hot-wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "hot-list" },
      _vm._l(_vm.hotList, function (item, index) {
        return _c(
          "li",
          { key: index, attrs: { uigs: "in_search_hotword_" + item.name } },
          [_c("a", { attrs: { href: item.url } }, [_vm._v(_vm._s(item.name))])]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hot-tab" }, [
      _c("ul", [
        _c("li", { staticClass: "cur", attrs: { uigs: "tab_0" } }, [
          _vm._v("\n        热搜\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }